var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.stories()),function(story,index){return _c('li',{key:index},[_c('h3',[_vm._v(_vm._s(story.headline))]),_c('p',[_vm._v(_vm._s(story.body))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }